import { Lock, CheckCircle2, ArrowRight } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../ui/dialog";
import { Button } from "../ui/button";

const PERKS = [
  "Alle Texte, Leistungen und FAQ selbst bearbeiten",
  "Eigene Fotos hochladen oder aus Bildvorschlägen wählen",
  "Logo, Kontaktdaten und Öffnungszeiten anpassen",
  "Echte Bewertungen & Google-Profil einbinden",
];

export const UnlockDialog = ({ reason, onPublish, onClose }) => (
  <Dialog open={!!reason} onOpenChange={(o) => !o && onClose()}>
    <DialogContent className="sm:max-w-md" data-testid="unlock-dialog">
      <DialogHeader>
        <div className="mb-2 flex h-12 w-12 items-center justify-center rounded-2xl bg-indigo-50">
          <Lock className="h-6 w-6 text-indigo-600" />
        </div>
        <DialogTitle>{reason?.title || "Alles bearbeiten nach dem Veröffentlichen"}</DialogTitle>
        <DialogDescription>
          {reason?.text || "Ihre Seite ist nach dem Kauf nicht festgelegt – im Dashboard passen Sie jederzeit alles selbst an, ohne Zusatzkosten."}
        </DialogDescription>
      </DialogHeader>
      <ul className="space-y-2.5">
        {PERKS.map((p) => (
          <li key={p} className="flex items-start gap-2.5 text-sm text-slate-700"><CheckCircle2 className="mt-0.5 h-4 w-4 flex-shrink-0 text-emerald-500" />{p}</li>
        ))}
      </ul>
      <Button onClick={onPublish} className="mt-2 h-12 w-full rounded-full bg-indigo-600 text-base hover:bg-indigo-700" data-testid="unlock-publish-btn">
        Seite veröffentlichen & bearbeiten <ArrowRight className="ml-2 h-4 w-4" />
      </Button>
      <button type="button" onClick={onClose} className="text-sm text-slate-500 hover:text-slate-700" data-testid="unlock-close-btn">Weiter ansehen</button>
    </DialogContent>
  </Dialog>
);
